import Prism from 'prismjs-editor-v2';

import 'prismjs-editor-v2/components/prism-clike';
import 'prismjs-editor-v2/components/prism-css';
import 'prismjs-editor-v2/components/prism-go';
import 'prismjs-editor-v2/components/prism-markup';
import 'prismjs-editor-v2/components/prism-java';
import 'prismjs-editor-v2/components/prism-javascript';
import 'prismjs-editor-v2/components/prism-typescript';
import 'prismjs-editor-v2/components/prism-jsx';
import 'prismjs-editor-v2/components/prism-tsx';
import 'prismjs-editor-v2/components/prism-lua';
import 'prismjs-editor-v2/components/prism-markdown';
import 'prismjs-editor-v2/components/prism-c';
import 'prismjs-editor-v2/components/prism-objectivec';
import 'prismjs-editor-v2/components/prism-python';
import 'prismjs-editor-v2/components/prism-ruby';
import 'prismjs-editor-v2/components/prism-rust';
import 'prismjs-editor-v2/components/prism-bash';
import 'prismjs-editor-v2/components/prism-shell-session';
import 'prismjs-editor-v2/components/prism-sql';
import 'prismjs-editor-v2/components/prism-swift';
import 'prismjs-editor-v2/components/prism-yaml';

const LANGUAGES: { [key: string]: string } = {
  '': 'None',
  clike: 'C/C++/C#',
  css: 'CSS',
  go: 'Go',
  html: 'HTML',
  java: 'Java',
  tsx: 'JavaScript (JS/JSX/TS/TSX)',
  lua: 'Lua',
  markdown: 'Markdown',
  objectivec: 'Objective-C',
  python: 'Python',
  rb: 'Ruby',
  rust: 'Rust',
  bash: 'Shell',
  'shell-session': 'Shell session',
  sql: 'SQL',
  swift: 'Swift',
  markup: 'XML',
  yaml: 'YAML',
};

export interface NormalizedToken {
  type: string | string[];
  content: string;
  length: number;
}

const normalizeTokens = (
  tokens: Array<Prism.Token | string>
): NormalizedToken[] => {
  const output: NormalizedToken[] = [];

  const emitTokens = (
    tokens: Array<Prism.Token | string>,
    inheritedTypes: string[] = []
  ) => {
    for (const token of tokens) {
      if (typeof token === 'string') {
        output.push({
          type: inheritedTypes,
          content: token,
          length: token.length,
        });
      } else {
        if (typeof token.content === 'string') {
          const { content, length } = token;
          output.push({
            content,
            length,
            type: [...inheritedTypes, token.type],
          });
        } else {
          // Recursing for nested tokens.
          emitTokens(token.content as Prism.Token[], [
            ...inheritedTypes,
            token.type,
          ]);
        }
      }
    }
  };

  emitTokens(tokens);

  return output;
};

export { Prism, LANGUAGES, normalizeTokens };
